import { brandsI18n } from '../../localization'
import { FormBuilder } from '../../modules/formBuilder'
import { LoadingScreen } from '../../modules/loadingScreen'
import Otp from '../../modules/otp'
import Review from '../../modules/review'
import { StatusScreen } from '../../modules/statusScreen'

export const bajajStateMap = {
  CC_START: {
    Component: LoadingScreen,
    props: {
      subTitle: brandsI18n.t('bajaj.ccStartSubTitle'),
    },
  },
  CC_BAJAJ_BASIC: {
    Component: FormBuilder,
  },
  CC_BAJAJ_ADDRESS_DETAILS: {
    Component: FormBuilder,
  },
  CC_BAJAJ_EMP: {
    Component: FormBuilder,
  },
  CC_BAJAJ_CONFIRMATION: {
    Component: FormBuilder,
  },
  CC_BAJAJ_REVIEW: {
    Component: Review,
  },
  CC_BAJAJ_OTP_SUBMIT: {
    Component: Otp,
  },
  CC_BAJAJ_SUBMIT_SUCCESS: {
    Component: StatusScreen,
  },
  CC_SUBMIT_PROGRESS: {
    Component: LoadingScreen,
    props: {
      subTitle:
        'Please wait while we are checking your eligibility with Bajaj Bank',
      timer: {
        enabled: true,
        onTimerEnd: ({ hash, navigation, state }) => {
          navigation?.replace?.('brandsCC', {
            hash,
            state,
          })
        },
        durationInSeconds: 59,
      },
      refresh: {
        shouldRefresh: true,
        refreshIntervalInSec: 5,
      },
    },
  },
  CC_BAJAJ_EDIT: {
    Component: StatusScreen,
    props: {
      status: {
        title: "Oops, Something's Not Right",
        subTitle: 'Following information in your form seems incorrect:',
        image: 'INCORRECT_DETAILS',
      },
      note: {
        position: 'bottom',
        localizationText: 'axis.note.editFormDetails',
      },
      buttons: [
        {
          title: 'Edit Application',
          action: 'STATE_MACHINE_POST',
        },
      ],
    },
  },
  CC_BAJAJ_SUBMIT_PROGRESS: {
    Component: StatusScreen,
  },
  CC_BAJAJ_REJECT: {
    Component: StatusScreen,
  },
  CC_BAJAJ_ERROR: {
    Component: StatusScreen,
  },
  CC_BAJAJ_REJECT_DUPLICATE: {
    Component: StatusScreen,
  },
}
